"use client";

import { Moon, Sun } from "lucide-react";
import { useEffect } from "react";
import { AnalyticsEvents, trackEvent } from "@/lib/client/analytics/product-analytics";
import { useThemeStore } from "@/lib/client/stores/useThemeStore";
import { cn, HStack, Switch } from "@/ui";

interface IThemeSelectorProps {
  className?: string;
}

/**
 * ThemeSelector component.
 * @param props - ThemeSelector props.
 * @returns Theme selector with swap icon.
 */
export const ThemeSelector = (props: IThemeSelectorProps) => {
  const { className } = props;
  const { theme, setTheme } = useThemeStore();

  useEffect(() => {
    // get theme from local storage
    if (localStorage.getItem("theme")) {
      const currentTheme = localStorage.getItem("theme");
      if (currentTheme) {
        setTheme(currentTheme);
      }
      return;
    }

    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    if (darkThemeMq.matches) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }, [setTheme]);

  return (
    <HStack className={cn("items-center gap-2", className)}>
      <Sun className="h-5 w-5" />
      <Switch
        checked={theme === "dark"}
        onCheckedChange={(checked: boolean) => {
          const newTheme = checked ? "dark" : "light";
          trackEvent(AnalyticsEvents.THEME_CHANGED, {
            theme: newTheme,
            previous_theme: theme,
          });
          setTheme(newTheme);
        }}
      />
      <Moon className="h-5 w-5" />
    </HStack>
  );
};
